import React from 'react';
import { Section, FadeIn } from './Shared';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export const RoseGoldDetails = () => {
  const comparison = [{
    feature: 'Programación de largo plazo',
    sin: 'Improvisás mes a mes sin sistema',
    con: 'Programa periodizado de 6 meses listo para aplicar'
  }, {
    feature: 'Progresión de tus alumnas',
    sin: 'Sin criterio científico de progresión',
    con: 'Macrociclos, mesociclos y microciclos diseñados para GAP'
  }, {
    feature: 'Semanas de descarga',
    sin: 'No las planificás y tus alumnas se agotan',
    con: 'Protocolo de deload incluido en cada fase'
  }, {
    feature: 'Ingresos digitales',
    sin: 'Solo vendés tu tiempo en clases presenciales',
    con: 'Sistema completo para crear y vender tu programa GAP online'
  }, {
    feature: 'Plataformas digitales',
    sin: 'No sabés por dónde empezar',
    con: 'Guía paso a paso de Hotmart, Teachable y WhatsApp Business'
  }, {
    feature: 'Lanzamiento de tu programa',
    sin: 'Sin plan, sin sistema, sin resultados',
    con: 'Plan de lanzamiento de 30 días listo para ejecutar'
  }];
  const premiumModules = [{
    icon: '🔬',
    title: 'Módulo 1 — Fundamentos de la Periodización',
    desc: 'La ciencia detrás de la periodización aplicada al GAP. Variables de carga, modelos de periodización y principios del entrenamiento de élite.'
  }, {
    icon: '📅',
    title: 'Módulo 2 — Diseño de Macrociclos GAP',
    desc: 'Cómo diseñar un programa de 6 meses con 3 fases: Adaptación Anatómica, Hipertrofia Funcional y Fuerza y Potencia.'
  }, {
    icon: '📆',
    title: 'Módulo 3 — Diseño de Mesociclos GAP',
    desc: 'La planificación mensual que hace predecible el progreso. La estructura 3+1 y cómo aplicar la descarga activa correctamente.'
  }, {
    icon: '📋',
    title: 'Módulo 4 — Diseño de Microciclos GAP',
    desc: 'La planificación semanal que estructura cada clase con precisión. Distribución de grupos musculares y variables de recuperación.'
  }, {
    icon: '🗓️',
    title: 'Módulo 5 — Programa Completo de 6 Meses',
    desc: 'Las 24 semanas de programa periodizado listas para aplicar desde mañana mismo.'
  }, {
    icon: '📊',
    title: 'Módulo 6 — Monitoreo y Ajuste del Programa',
    desc: 'Cómo saber si el programa está funcionando y qué ajustar si no.'
  }];
  const digitalModules = [{
    icon: '💼',
    title: 'Módulo 1 — El Modelo de Negocio Digital',
    desc: 'Los 4 modelos de negocio digital, el ecosistema completo de una instructora GAP y el mindset de emprendedora digital.'
  }, {
    icon: '📐',
    title: 'Módulo 2 — Diseñá tu Programa GAP Digital',
    desc: 'Encontrá tu nicho, diseñá la transformación de tu programa y elegí el nombre y posicionamiento perfecto.'
  }, {
    icon: '🎬',
    title: 'Módulo 3 — Producción de Contenido Digital',
    desc: 'Cómo grabar clases profesionales desde tu casa sin equipo caro. Setup, grabación, edición en CapCut y producción de materiales complementarios.'
  }, {
    icon: '💻',
    title: 'Módulo 4 — Plataformas y Tecnología',
    desc: 'Hotmart, Teachable, Gumroad, WhatsApp + Drive. Cuál usar según tu momento y cómo configurarlo paso a paso.'
  }, {
    icon: '💰',
    title: 'Módulo 5 — Precio y Empaquetado',
    desc: 'Cómo fijar el precio que refleja el valor real de tu programa. Estrategia de 3 paquetes y cómo manejar la inflación argentina.'
  }, {
    icon: '🛒',
    title: 'Módulo 6 — Tu Sistema de Ventas Online',
    desc: 'Página de ventas, Instagram como canal de ventas, scripts de WhatsApp y cómo manejar las objeciones más comunes.'
  }, {
    icon: '🚀',
    title: 'Módulo 7 — Lanzamiento de tu Programa',
    desc: 'El plan de lanzamiento de 30 días completo: siembra, anticipación, cuenta regresiva y apertura de inscripciones.'
  }, {
    icon: '⚙️',
    title: 'Módulo 8 — Escalabilidad y Automatización',
    desc: 'Cómo hacer que tu negocio GAP digital trabaje sin vos. Los 4 niveles de escalabilidad y las métricas que importan.'
  }];
  return <Section bg="white" data-id="element-256">
      <div className="max-w-5xl mx-auto" data-id="element-257">
        <FadeIn className="text-center mb-8 md:mb-12" data-id="element-258">
          <h2 className="text-2xl md:text-4xl font-extrabold text-charcoal mb-3 md:mb-4" data-id="element-259">
            ¿QUÉ AGREGA EL{' '}
            <span className="text-gold" data-id="element-260">GAP 360 ROSE GOLD EDITION™</span>?
          </h2>
          <p className="text-base md:text-xl text-gray-600" data-id="element-261">
            El sistema que convierte a una buena instructora en una referente
            del GAP
          </p>
        </FadeIn>

        {/* Desktop table */}
        <FadeIn className="mb-12 md:mb-20 hidden md:block overflow-x-auto pb-4" data-id="element-262">
          <table className="w-full min-w-[800px] border-collapse bg-white shadow-lg rounded-2xl overflow-hidden" data-id="element-263">
            <thead data-id="element-264">
              <tr className="bg-charcoal text-white" data-id="element-265">
                <th className="p-4 text-left font-bold w-1/4" data-id="element-266">Situación</th>
                <th className="p-4 text-left font-bold w-1/3 text-gray-400" data-id="element-267">
                  Sin Rose Gold Edition
                </th>
                <th className="p-4 text-left font-bold w-5/12 text-gold" data-id="element-268">
                  Con Rose Gold Edition
                </th>
              </tr>
            </thead>
            <tbody data-id="element-269">
              {comparison.map((row, i) => <tr key={i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50" data-id="element-270">
                  <td className="p-4 font-bold text-charcoal" data-id="element-271">{row.feature}</td>
                  <td className="p-4 text-gray-500 flex items-start gap-2" data-id="element-272">
                    <XCircleIcon className="text-red-400 shrink-0 mt-1" size={18} data-id="element-273" />{' '}
                    {row.sin}
                  </td>
                  <td className="p-4 text-charcoal font-semibold bg-gold/5" data-id="element-274">
                    <div className="flex items-start gap-2" data-id="element-275">
                      <CheckCircle2Icon className="text-gold shrink-0 mt-1" size={18} data-id="element-276" />{' '}
                      {row.con}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </FadeIn>

        {/* Mobile stacked cards */}
        <FadeIn className="mb-8 md:hidden space-y-3" data-id="element-277">
          {comparison.map((row, i) => <div key={i} className="bg-gray-50 rounded-xl p-3 border border-gray-200" data-id="element-278">
              <p className="font-bold text-charcoal text-sm mb-2" data-id="element-279">
                {row.feature}
              </p>
              <div className="flex items-start gap-2 mb-1.5" data-id="element-280">
                <XCircleIcon className="text-red-400 shrink-0 mt-0.5" size={14} data-id="element-281" />
                <p className="text-gray-500 text-xs" data-id="element-282">{row.sin}</p>
              </div>
              <div className="flex items-start gap-2 bg-gold/10 rounded-lg p-2" data-id="element-283">
                <CheckCircle2Icon className="text-gold shrink-0 mt-0.5" size={14} data-id="element-284" />
                <p className="text-charcoal font-semibold text-xs" data-id="element-285">{row.con}</p>
              </div>
            </div>)}
        </FadeIn>

        <div className="mb-8 md:mb-16" data-id="element-286">
          <FadeIn className="mb-4 md:mb-8" data-id="element-287">
            <div className="bg-charcoal text-white inline-block px-4 md:px-6 py-1.5 md:py-2 rounded-full font-bold text-xs md:text-base mb-4 md:mb-6" data-id="element-288">
              ✅ GAP 360 ROSE GOLD EDITION™ INCLUYE:
            </div>
            <h3 className="text-xl md:text-3xl font-bold text-charcoal flex items-center gap-2 md:gap-3" data-id="element-289">
              <span className="text-3xl md:text-4xl" data-id="element-290">📊</span> GAP PREMIUM —
              Programa de 6 Meses con Periodización Avanzada
            </h3>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-291">
            {premiumModules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-292">
                <div className="bg-cream p-3 md:p-6 rounded-lg md:rounded-xl border border-gray-200 h-full" data-id="element-293">
                  <h4 className="font-bold text-sm md:text-lg text-charcoal mb-1 md:mb-2 flex items-start gap-2" data-id="element-294">
                    <span className="text-xl md:text-2xl" data-id="element-295">{mod.icon}</span>{' '}
                    <span data-id="element-296">{mod.title}</span>
                  </h4>
                  <p className="text-gray-600 text-xs md:text-sm" data-id="element-297">{mod.desc}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <div data-id="element-298">
          <FadeIn className="mb-4 md:mb-8" data-id="element-299">
            <h3 className="text-xl md:text-3xl font-bold text-charcoal flex items-center gap-2 md:gap-3" data-id="element-300">
              <span className="text-3xl md:text-4xl" data-id="element-301">💻</span> ACADEMIA GAP
              DIGITAL — Cómo Crear y Vender tus Propios Programas Online
            </h3>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-302">
            {digitalModules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-303">
                <div className="bg-cream p-3 md:p-6 rounded-lg md:rounded-xl border border-gray-200 h-full" data-id="element-304">
                  <h4 className="font-bold text-sm md:text-lg text-charcoal mb-1 md:mb-2 flex items-start gap-2" data-id="element-305">
                    <span className="text-xl md:text-2xl" data-id="element-306">{mod.icon}</span>{' '}
                    <span data-id="element-307">{mod.title}</span>
                  </h4>
                  <p className="text-gray-600 text-xs md:text-sm" data-id="element-308">{mod.desc}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </Section>;
};